// import Bowser from "bowser"; // comment me in if needed
// import $ from "jquery";
// import "slick-carousel";
import Splide from "@splidejs/splide";
import MicroModal from "micromodal";
import Cookies from "js-cookie";
import setLocationCookie from "./setLocationCookie";
import updateUserLocation from "./updateUserLocation";

// MicroModal
MicroModal.init({
  onShow: function() {
    document.querySelector("html").classList.add("locked");
  },
  onClose: function() {
    document.querySelector("html").classList.remove("locked");
  }
});

jQuery(document).ready(function($) {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
    $("body").addClass("touch");
  }

  // // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  // const userBrowser = Bowser.getParser(window.navigator.userAgent);
  // const browser = userBrowser.getBrowser();

  // if (browser.name === "Internet Explorer" && browser.version == "11.0") {
  //   $("body").addClass("ie-11");
  // } else if (browser.name === "Safari") {
  //   $("body").addClass("safari");
  // }

  // Helper functions
  function toggleMask() {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");
  }

  function removeMask() {
    $("html").removeClass("locked");
    $("body").removeClass("locked masked");
  }

  function toggleMenu(icon, menu) {
    icon.toggleClass("active");
    menu.slideToggle();
  }

  function closeMenu(icon, menu) {
    icon.removeClass("active");
    menu.slideUp();
  }

  // Menus 
  // Menu - Toggle on click or enter key
  $(".menu-icon").on("click", function() {
    toggleMask();

    toggleMenu($(this), $(".nav--mobile"));
  });

  // Menu - close on resize to desktop
  $(window).on("resize", function() {
    if( $(".nav--mobile").length && $(window).width() > 1024 && $(".nav--mobile").css("display") == "block" ) {
      removeMask(); 

      closeMenu($(".menu-icon"), $(".nav--mobile"));
    }
  });
  
  // Menu - Close on outside click 
  $(document).on("click", function(e) {
    if( $(".site-header").length ) {
      if( !$(e.target).closest(".site-header").length && $(".nav--mobile").css("display") == "block" ) {
        removeMask();
  
        closeMenu($(".menu-icon"), $(".nav--mobile"));
      }
  
      if( !$(e.target).closest(".site-header__utility__location").length && $(".nav--locations").css("display") == "block" ) {
        $(".nav--locations").slideUp();
      }
    }
  });

  // Menu - Close on ESC
  $(document).on("keyup", function(e) {
    if( $(".site-header").length ) {
      if( e.which == 27 ) {
        if( $(".nav--mobile").css("display") == "block" ) {
          removeMask();

          closeMenu($(".menu-icon"), $(".nav--mobile"));
        }

        if( $(".nav--locations").css("display") == "block" ) {
          $(".nav--locations").slideUp();
        }
      }
    }
  });

  // Menu - Mobile accordions 
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).toggleClass("open");
    $(this).siblings(".sub-menu").slideToggle();
  });

  // Menu - Mobile footer accordions 
  $(".nav--footer .menu-item-has-children > a").on("click", function(e) {
    if( $(window).width() < 768 ) {
      e.preventDefault();

      $(this).toggleClass("open");
      $(this).siblings(".sub-menu").slideToggle();
    }
  });

  // Mobile menu accordions resize fix
  $(window).on("resize", function() {
    if( $(window).width() >= 768 && $(".site-footer").length ) {
      $(".nav--footer .sub-menu").removeAttr("style");
    }
  });

  // Cookie
  if( $(".site-header").length ) {
    // Set initial location cookie, if not already set
    if( !Cookies.get("your_location") ) {

      // Grab WP Engine Geotarget location ID & data
      let userLoc = $("#your-location"),
        id = userLoc.attr("data-id"),
        title = userLoc.text(),
        url = userLoc.attr("href"),
        lat = userLoc.attr("data-lat"),
        lng = userLoc.attr("data-lng"),
        phone = userLoc.attr("data-phone");

      // params: id, title, url, lat, lng, phone
      setLocationCookie(id, title, url, lat, lng, phone);

    // Otherwise, if cookie already set
    } else {

      // Grab location data that matches cookie id
      let cookie = Cookies.get("your_location"),
        match = $(".nav--locations__location[data-id='" + cookie + "']");

      // Grab match's info to update visible cookie
      let id = match.attr("data-id"),
        title = match.text(),
        url = match.attr("data-link"),
        lat = match.attr("data-lat"),
        lng = match.attr("data-lng"),
        phone = match.attr("data-phone");

      // And pass it to updateUserLocation function 
      // params: id, title, url, lat, lng, phone;
      updateUserLocation(id, title, url, lat, lng, phone);

    }
  }

  // Change location menu toggle
  $(".site-header__change-location").on("click", function() {
    $(".nav--locations").slideToggle();
  });

  // Change locations sub-menu toggle 
  $(".nav--locations__state span").on("click", function() {
    $(this).parents(".nav--locations__state").siblings(".nav--locations__state").find("span").removeClass("open");
    $(this).parents(".nav--locations__state").siblings(".nav--locations__state").find("ul").slideUp();

    $(this).toggleClass("open");
    $(this).siblings("ul").slideToggle();
  });

  // Update your location link
  $(".nav--locations__location").on("click", function() {
    // Get current cookie id & state 
    let cookieId = Cookies.get("your_location"),
      cookieState = $(".nav--locations__location[data-id='" + cookieId + "']").attr("data-state");

    // Get current link, text, & coordinates (and id)
    let newText = $(this).text(),
      newLink = $(this).attr("data-link"),
      newLat = $(this).attr("data-lat"),
      newLng = $(this).attr("data-lng"),
      newId = $(this).attr("data-id"),
      newPhone = $(this).attr("data-phone"),
      newState = $(this).attr("data-state");

    // Update browser cookie
    // params: id, title, url, lat, lng, phone
    setLocationCookie(newId, newText, newLink, newLat, newLng, newPhone);

    $(".nav--locations").slideToggle();

    // Then, refresh the page (if state is different)
    if( cookieState !== newState ) {
      window.location.reload();
    }
  });

  // Collapsible banner 
  $(".collapsible-banner__trigger button").on("click", function() {
    $(this).toggleClass("open");
    $(this).parents(".collapsible-banner").find(".collapsible-banner__content").slideToggle();
  });

  // Form Label Animation
  $(".gform_wrapper form .animated").find("input, select, textarea").on("focusin", function() {
    $(this).parents(".animated").children("label").addClass("active-position active-weight active-color");
  
    // Off focus
    $(".gform_wrapper form .animated").find("input, select, textarea").on("focusout", function() {
      if( $(this).val() !== "" ) { // Remove active weight and keep raised position if input has content
        $(this).parents(".animated").children("label").removeClass("active-weight active-color");
      } else { // Else remove both weight and raised position
        $(this).parents(".animated").children("label").removeClass("active-position active-weight active-color");
      }
    });
  });

  // Slider Section 
  if( $(".slider-section").length ) {
    // Splidejs slider
    $(".slider-section").each(function() {
      new Splide(this, {
        type: "fade",
        perPage: 1,
        pagination: false,
        rewind: true
      }).mount();
    });

    // Slick Slider
    // $(".slider-section").slick({
    //   arrows: true,
    //   dots: false,
    //   adaptiveHeight: false,
    //   fade: true,
    // });
  }

  // Accordions section 
  $(".accordion__header").on("click", function() {
    // Close other accordions
    $(this).parents(".accordions-section").find(".accordion__header").not(this).find("i").removeClass("active");
    $(this).parents(".accordions-section").find(".accordion__header").not(this).siblings(".accordion__content").slideUp();

    // Toggle this one
    if( $(this).find("i").hasClass("active") ) {
      $(this).find("i").removeClass("active");
    } else {
      $(this).find("i").addClass("active");
    }
    
    $(this).siblings(".accordion__content").slideToggle();
  });

  // Smooth anchor link scrolling 
  $("a[href*=\\#]").on("click", function (e) {
    let slug = this.href.split("#")[1].replace("#", "");

    // Only if no matching modal
    if( !$(".modal#modal-" + slug).length ) {
      e.preventDefault();
      if(this.pathname === window.location.pathname) {
        // Store hash
        let hash = this.hash;
  
        $("html, body").animate({
          scrollTop: $(hash).offset().top,
        }, 800, function(){
  
          window.location.hash = hash;
        });
      }
    }
  });

  // Trigger matching modal (if there) when hash 
  if( window.location.hash) {
    let hash = window.location.hash.replace("#", "");

    if( $(".modal#modal-" + hash).length ) {
      MicroModal.show("modal-" + hash);
    }
  }

  // Trigger matching modal (if there) when hash on nav button click
  $(".nav--footer a").on("click", function(e) {
    let hash = this.href.split("#")[1].replace("#", "");

    if( hash && $(".modal#modal-" + hash).length ) {
      e.preventDefault();

      MicroModal.show("modal-" + hash);
    }
  });

});
